import { ForwardedRef, forwardRef, FunctionComponent } from "react";
import { IInputProps } from "./interfaces/IInputProps";
import "./styles/input.css";

export const Input: FunctionComponent<IInputProps> = forwardRef(function Input(props: IInputProps, ref: ForwardedRef<HTMLInputElement>) {
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <input {...props} className={`cui-base-input ${props.className}`} ref={ref} />;
});
